import { TooltipProvider } from "@reactive-resume/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router";

import { helmetContext } from "../constants/helmet";
import { queryClient } from "../libs/query-client";
import { BootSplashGate } from "../components/boot-splash-gate";
import { EmailOptInNudge } from "../components/email-optin-nudge";
import { InstallPwaBanner } from "../components/install-pwa-banner";
import { PushOptInNudge } from "../components/push-nudge";
import { NotificationRealtimeBridge } from "../services/notification";
import { AuthRefreshProvider } from "./auth-refresh";
import { DialogProvider } from "./dialog";
import { LocaleProvider } from "./locale";
import { ThemeProvider } from "./theme";
import { Toaster } from "./toaster";
import { Theme } from "@radix-ui/themes";
export const Providers = () => (
  <LocaleProvider>
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}>
        <AuthRefreshProvider>
          <ThemeProvider>
            <TooltipProvider>
              <DialogProvider>
                {/* Boot splash : fondu de sortie du premier écran de marque (index.html) */}
                <BootSplashGate />
                {/* Temps réel : socket → cache notifications + toasts + badges */}
                <NotificationRealtimeBridge />
                {/* Bannière d'installation PWA (beforeinstallprompt) */}
                <InstallPwaBanner />
                {/* Nudge opt-in push (toast récurrente à CTA vert, cadence localStorage) */}
                <PushOptInNudge />
                {/* Nudge opt-in e-mail (J+1, après interaction, cadence SoftPrompt) */}
                <EmailOptInNudge />
                <Outlet />
                <Toaster />
              </DialogProvider>
            </TooltipProvider>
          </ThemeProvider>
        </AuthRefreshProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </LocaleProvider>
);
